<arm-dialog (onCancel)="cancel()"
            (onSubmit)="submit()"
            class="voip-peers-dialog"
            [hideOkButton]="!isAuthorized"
            [disabled]="!mapForm.form.valid"
            [title]="title">

    <form #mapForm="ngForm" autocomplete="off">
        <mat-form-field class="fullWidth">
            <mat-label>Name</mat-label>
            <input matInput required [(ngModel)]="data.selectedItem.name" name="name">
            <mat-error>
                Name is <strong>required</strong>
            </mat-error>
        </mat-form-field>

        <mat-form-field class="fullWidth">
            <mat-label>Peer Type</mat-label>
            <mat-select required [(ngModel)]="data.selectedItem.deviceType" name="deviceType">
                <mat-option *ngFor="let item of sipHeaderOptions" [value]="item">
                    {{item}}
                </mat-option>
            </mat-select>
        </mat-form-field>

        <ac-input-container label="CAC State">
            <ac-select [(acModel)]="data.selectedItem.cacState"
                       [items]="cacStateOptions">
            </ac-select>
        </ac-input-container>
    </form>
</arm-dialog>
